module.exports = __webpack_public_path__ + "img/无数据.004f771d.svg";